import { useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function Navbar() {
  const [sticky, setSticky] = useState(false);
  const [mobile, setMobile] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 150) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  window.addEventListener("scroll", handleScroll);

  const goTop = () => {
    window.scrollTo({
      top: (0, 0),
      behavior: "smooth",
    });
  };

  const openMobile = () => {
    setMobile(!mobile);
  };

  return (
    <>
      <nav className={sticky ? "sticky-nav" : ""}>
        <div className="navbar">
          <Link to="/">
            <p onClick={goTop}>Bitter Coin</p>
          </Link>
          <ul>
            <li>
              <HashLink to="#home">Home</HashLink>
            </li>
            <li>
              <HashLink to="#market">Market</HashLink>
            </li>
            <li>
              <HashLink to="#choose-us">Choose Us</HashLink>
            </li>
            <li>
              <HashLink to="#join">Join</HashLink>
            </li>
          </ul>
          <span>
            <i className="fa-brands fa-twitter"></i>
            <i className="fa-brands fa-discord"></i>
            {/* mobile */}
            <i
              onClick={openMobile}
              className="fa-solid fa-bars-staggered hamburger-menu"
            ></i>
          </span>
        </div>
      </nav>

      {/* mobile nav */}
      <div className={`mobile-nav ${mobile ? "mobile-up" : ""}`}>
        <i onClick={openMobile} className="fa-solid fa-xmark close-mobile"></i>
        <ul>
          <li onClick={openMobile}>
            <HashLink to="#home">Home</HashLink>
          </li>
          <li onClick={openMobile}>
            <HashLink to="#market">Market</HashLink>
          </li>
          <li onClick={openMobile}>
            <HashLink to="#choose-us">Choose Us</HashLink>
          </li>
          <li onClick={openMobile}>
            <HashLink to="#join">Join</HashLink>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Navbar;
